import { createAction, handleActions } from 'redux-actions'

const setData = createAction('MODULES/VALUATION_SERVICES_POPOVER/SET_DATA')
const resetData = createAction('MODULES/VALUATION_SERVICES_POPOVER/RESET_DATA')

const defaultState = null

const reducer = handleActions(
  {
    [setData]: (state, { payload }) => payload,
    [resetData]: () => defaultState,
  },
  defaultState,
)

export { setData, resetData, reducer }
